module.exports = __webpack_public_path__ + "img/gb63.prt.8dea95c6.jpg";